import { Permission } from 'shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  PayItemConnection,
  useConnectionsContext,
} from '../../ConnectionsContext'
import { useGlobalState } from 'context/GlobalStateContext'
import { useCreateGoogleSheetPayItemConnectionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import CreateBody from './CreateBody'
import { CreateBodyValues } from './CreateBody/types'
import { errorHandler } from 'hooks/errorHandler'

export function useCreate(): CreateHeaderActionOptions<PayItemConnection> {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { refetch } = useConnectionsContext()
  const [createGoogleSheet] = useCreateGoogleSheetPayItemConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createGoogleSheetPayItemConnection: {
        googleSheet: {
          connection: { name },
        },
      },
    }) => simpleCreateNotification(name ?? 'Google Sheet Connection'),
  })
  return {
    entity: 'Connection',
    permission: Permission.CreatePayItemConnection,
    modal: {
      type: 'simple',
      body: <CreateBody />,
      onOk: async ({ name, group, googleSheet }: CreateBodyValues) => {
        let promise
        if (!!googleSheet) {
          if (!projectId) return errorHandler('projectId is not defined')
          const { documentId, sheetId, url, ...rest } = googleSheet
          if (url || (documentId && sheetId))
            promise = createGoogleSheet({
              variables: {
                input: {
                  ...rest,
                  groupId: group?.value as string,
                  url,
                  documentId,
                  sheetId: sheetId ? parseInt(sheetId) : undefined,
                  name,
                  projectId,
                },
              },
            })
        }
        if (promise) {
          await promise
          refetch()
        }
      },
    },
  }
}
